export const contactsData = {
    email: 'prattaygub@gmail.com',
    phone: '+8801788161616',
    address: 'Tangail,Dhaka,Bangladesh ',

    sheetAPI: ''
}